class StoreCart {
  constructor() {
    this.drawer = document.querySelector('[data-cart-drawer]');
    this.overlay = document.querySelector('[data-cart-overlay]');
    this.itemsEl = document.querySelector('[data-cart-items]');
    this.countEls = document.querySelectorAll('[data-cart-count]');
    this.subtotalEls = document.querySelectorAll('[data-cart-subtotal]');
    this.toast = document.querySelector('[data-cart-toast]');

    this.bindEvents();
  }

  cartAddUrl() {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}cart/add.js`;
  }

  cartUrl() {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}cart.js`;
  }

  bindEvents() {
    document.querySelectorAll('[data-ajax-add]').forEach((form) => {
      form.addEventListener('submit', (e) => this.handleAdd(e, form));
    });

    document.querySelectorAll('[data-cart-open]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    document.querySelectorAll('[data-cart-close]').forEach((btn) => {
      btn.addEventListener('click', () => this.close());
    });

    this.overlay?.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }

  async handleAdd(e, form) {
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const originalText = btn?.textContent;
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }

    try {
      const formData = new FormData(form);
      const res = await fetch(this.cartAddUrl(), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      if (!res.ok) throw new Error('Add failed');
      const item = await res.json();
      await this.refresh();
      this.open();
      this.showToast(item.product_title || 'Item added to cart');
    } catch {
      form.submit();
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.textContent = originalText;
      }
    }
  }

  async refresh() {
    const res = await fetch(this.cartUrl(), { headers: { Accept: 'application/json' } });
    const cart = await res.json();
    this.render(cart);
    return cart;
  }

  escapeHtml(str) {
    return String(str ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  render(cart) {
    this.countEls.forEach((el) => {
      if (el.dataset.cartCountBadge !== undefined) {
        el.textContent = String(cart.item_count);
        el.hidden = cart.item_count === 0;
      } else {
        el.textContent = cart.item_count > 0 ? ` (${cart.item_count})` : '';
      }
    });

    this.subtotalEls.forEach((el) => {
      el.textContent = this.formatMoney(cart.total_price);
    });

    if (!this.itemsEl) return;

    if (!cart.items || cart.items.length === 0) {
      this.itemsEl.innerHTML = '<p class="store-cart-drawer__empty">Your cart is empty</p>';
      return;
    }

    this.itemsEl.innerHTML = cart.items
      .map((item) => {
        const title = this.escapeHtml(item.product_title);
        const variant =
          item.variant_title && item.variant_title !== 'Default Title'
            ? `<span class="store-cart-drawer__item-variant">${this.escapeHtml(item.variant_title)}</span>`
            : '';
        const image = item.image
          ? `<img src="${this.escapeHtml(item.image)}" alt="${title}" width="72" height="72" loading="lazy">`
          : '';
        return `
        <div class="store-cart-drawer__item">
          <a href="${this.escapeHtml(item.url)}" class="store-cart-drawer__item-image">
            ${image}
          </a>
          <div class="store-cart-drawer__item-info">
            <a href="${this.escapeHtml(item.url)}" class="store-cart-drawer__item-title">${title}</a>
            ${variant}
            <span class="store-cart-drawer__item-price">${this.formatMoney(item.final_line_price)}</span>
          </div>
        </div>`;
      })
      .join('');
  }

  formatMoney(cents) {
    const amount = (Number(cents) || 0) / 100;
    const currency = window.Shopify?.currency?.active;

    try {
      if (currency && typeof Intl !== 'undefined') {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency,
        }).format(amount);
      }
    } catch {
      /* fall through */
    }

    if (typeof window.Shopify?.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    return `$${amount.toFixed(2)}`;
  }

  open() {
    this.drawer?.setAttribute('data-open', '');
    this.overlay?.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.drawer?.removeAttribute('data-open');
    this.overlay?.removeAttribute('data-open');
    document.body.style.overflow = '';
  }

  showToast(message) {
    if (!this.toast) return;
    this.toast.textContent = message;
    this.toast.setAttribute('data-show', '');
    setTimeout(() => this.toast.removeAttribute('data-show'), 3000);
  }
}

function initMobileMenu() {
  const toggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (!toggle || !mobileNav || toggle.dataset.menuBound === 'true') return;

  toggle.dataset.menuBound = 'true';

  const setOpen = (open) => {
    if (open) {
      mobileNav.classList.add('is-open');
      mobileNav.setAttribute('data-open', '');
      mobileNav.removeAttribute('hidden');
      mobileNav.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
      toggle.classList.add('is-open');
    } else {
      mobileNav.classList.remove('is-open');
      mobileNav.removeAttribute('data-open');
      mobileNav.setAttribute('hidden', '');
      mobileNav.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      toggle.classList.remove('is-open');
    }
  };

  const onToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const isOpen = mobileNav.classList.contains('is-open');
    setOpen(!isOpen);
  };

  // Use pointerup once — works for mouse + touch without double-toggle
  toggle.addEventListener('click', onToggle);

  mobileNav.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setOpen(false));
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setOpen(false);
  });

  document.addEventListener('click', (e) => {
    if (!mobileNav.classList.contains('is-open')) return;
    if (toggle.contains(e.target) || mobileNav.contains(e.target)) return;
    setOpen(false);
  });
}

function bootStore() {
  window.storeCart = new StoreCart();
  initMobileMenu();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootStore);
} else {
  bootStore();
}
